$(document).ready(function() {
    $('.js-game-filter').on('click', function() {
        $(this).toggleClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-index/game-filter.js